import React from 'react'
import { Form, Button, Input, TimePicker, message, Modal } from 'antd';
import { connect } from 'dva'
import moment from 'moment';
import { withRouter } from 'react-router-dom'
import SelectFrontCover from "../components/index";
import style from './index.less'
import SelectCollCover from '../components/collindex'
import question from '../../../../../assets/teacherCare/question.png'

const { TextArea } = Input;
const format = 'HH:mm';
@connect(({ getPushRuless }) => ({
  ...getPushRuless,
}))
@withRouter
class BirthdayPush extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lengthcoll: '',
      lengthper: '',
      idper: '',
      idcoll: '',
    }
  }

  componentDidMount () {
    this.updatedate()
    const { dispatch } = this.props
    return dispatch({
      type: 'getPushRuless/ismanager'
    })
  }



  getdata () {
    const { dispatch } = this.props;
    return dispatch({
      type: 'getPushRuless/getPushRule',
      payload: {
        pushType: 'birthday'
      }
    })
  }



  // 提交表单
  handleSubmit = e => {
    const { manager } = this.props
    const { result } = manager || {}
    if (result) {
      e.preventDefault();
      const { form, dispatch } = this.props
      const { idper, idcoll } = this.state
      form.validateFields((err, values) => {
        if (!err) {
          console.log(values);
          const { coverInfocoll, coverInfoper, pushtiemper, pushtimecoll, pushwordcoll, pushwordper } = values || {}
          const selectVaules = {
            personRule: {
              coverConfigList: (coverInfoper || {}),
              id: idper || null,
              pushText: (pushwordper || ''),
              pushTime: moment(pushtiemper).format("HH:mm"),
              pushType: "birthday"
            },
            colleagueRule: {
              coverConfigList: (coverInfocoll || {}),
              id: idcoll || null,
              pushText: (pushwordcoll || ''),
              pushTime: moment(pushtimecoll).format("HH:mm"),
              pushType: "birthday"
            },
            pushType: 'birthday'
          }
          dispatch({
            type: 'getPushRuless/upDate',
            payload: {
              selectVaules,
              visible: true
            }
          })
        } else {
          message.error((err.pushwordper || err.pushwordcoll || err.coverInfoper || err.coverInfocoll).errors[0].message)
        }
      });
    } else {
      message.error("对不起，您还没有该权限，请联系管理员开通！")
    }

  };

  onCoverListChange = (coverList) => {
    const { dispatch } = this.props;
    // 保存选中通知类型和对应的封面列表
    dispatch({
      type: 'safeClockCreate/save',
      payload: {
        coverList,
      },
    });
  }

  // 保存表单数据
  handleFormDataChange = payload => {
    const { dispatch, form } = this.props;
    const { setFieldsValue } = form;
    setFieldsValue({ ...payload });
    dispatch({
      type: "safeClockCreate/saveFormData",
      payload: { ...payload }
    });
  };

  // 同事推送祝福语改变
  onChangeColleagueText = e => {
    this.setState({
      lengthcoll: e.target.value.length
    })
  };

  // 本人推送祝福语改变
  onChangePersonText = e => {
    this.setState({
      lengthper: e.target.value.length
    })
  }

  // 确认提交
  hideModal = () => {
    const { dispatch, selectVaules } = this.props
    dispatch({
      type: 'getPushRuless/subPushrules',
      payload: {
        ...selectVaules
      }
    })
    dispatch({
      type: 'getPushRuless/upDate',
      payload: {
        visible: false
      }
    })
  }

  // 自定义校验
  handleConfirmBirthday = (rule, value, callback) => {
    const selectCover = (((value || [])[(value || []).map(o => o.wthrChoose).indexOf('1')]) || {}).coverUrl
    if (value && !selectCover) {
      callback('请选择推送封面');
    }
    callback();
  };

  onCancel = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'getPushRuless/upDate',
      payload: {
        visible: false
      }
    })
  };

  async updatedate () {
    const pushdata = await this.getdata()
    const { colleagueRule, personRule } = pushdata || {}
    const pushTextper = (personRule || {}).pushText
    const pushTextcoll = (colleagueRule || {}).pushText
    this.setState({
      lengthcoll: pushTextcoll.length,
      lengthper: pushTextper.length,
      idper: personRule.id,
      idcoll: colleagueRule.id
    })
  }


  render () {
    const { form, pushdata, visible } = this.props
    const { lengthcoll,
      lengthper } = this.state
    const { getFieldDecorator } = form;
    const { colleagueRule, personRule } = pushdata || {}

    // 推送时间限制
    function range (start, end) {
      const result = [];
      // eslint-disable-next-line no-plusplus
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    }

    function disabledHours () {
      const hours = range(0, 60);
      hours.splice(8, 14);
      return hours;
    }

    function disabledMinutes () {
      return range(1, 60);

    }

    const selectCoverProps = {
      personRule,
      form,
      pushdata,
      colleagueRule,
      onCoverListChange: this.onCoverListChange,
      handleOk: this.handleFormDataChange
    };

    return (
      <div className={style.push}>
        <div className={style.push_root}>
          <div className={style.push_header}>
            本人推送规则
          </div>
          <Form
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 14,
            }}
            onSubmit={this.handleSubmit}
            layout="horizontal"
            labelAlign="right"
          >
            <Form.Item
              label="推送封面"
              colon
            >
              {getFieldDecorator("coverInfoper", {
                initialValue: (personRule || {}).coverConfigList,
                valuePropName: 'coverInfoper',
                rules: [
                  {
                    required: true,
                  },
                  {
                    validator: this.handleConfirmBirthday,
                  },
                ]
              })(<SelectFrontCover {...selectCoverProps} />)}
              <div className={style.push_defual}>随机推送选择的模板封面</div>
            </Form.Item>
            <Form.Item
              label="推送语"
              colon
            >
              {
                getFieldDecorator("pushwordper", {
                  initialValue: (personRule || {}).pushText,
                  rules: [
                    {
                      required: true,
                      message: "推送语不能为空"
                    },
                  ]
                })(
                  <TextArea maxLength={30} placeholder="请输入祝福语！" style={{ wordBreak: "break-all", wordWrap: "break-word" }} onChange={this.onChangePersonText} />
                )
              }
              <div className={style.limit_word} style={{ color: lengthper >= 30 ? "red" : "#000000" }}>{lengthper < 30 ? lengthper : 30}/30</div>
            </Form.Item>
            <Form.Item
              label="推送时间"
              colon
            >
              {
                getFieldDecorator("pushtiemper", {
                  initialValue: moment((personRule || {}).pushTime || '09:00', format),
                  rules: [
                    {
                      required: true,
                    },
                  ]
                })(
                  <TimePicker
                    format={format}
                    disabledHours={disabledHours}
                    disabledMinutes={disabledMinutes}
                    hideDisabledOptions
                  />
                )
              }
              <div className={style.push_defual}>
                说明: 生日当天的推送时间
              </div>
            </Form.Item>
          </Form>
        </div>
        <div className={style.push_root}>
          <div className={style.push_header}>
            同事推送规则
          </div>
          <Form
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 14,
            }}
            onSubmit={this.handleSubmit}
            layout="horizontal"
            labelAlign="right"
          >
            <Form.Item
              label="推送封面"
              colon
            >
              {getFieldDecorator("coverInfocoll", {
                initialValue: (colleagueRule || {}).coverConfigList,
                valuePropName: "coverInfocoll",
                rules: [
                  {
                    required: true,
                  },
                  {
                    validator: this.handleConfirmBirthday,
                  },
                ]
              })(<SelectCollCover {...selectCoverProps} />)}
              <div className={style.push_defual}>随机推送选择的模板封面</div>
            </Form.Item>
            <Form.Item
              label="推送语"
              colon
            >
              {getFieldDecorator("pushwordcoll", {
                initialValue: (colleagueRule || {}).pushText,
                rules: [
                  {
                    required: true,
                    message: "推送语不能为空"
                  },
                ]
              })(<TextArea maxLength={30} placeholder="请输入祝福语！" style={{ wordBreak: "break-all", wordWrap: "break-word" }} onChange={this.onChangeColleagueText} />)}
              <div className={style.limit_word} style={{ color: lengthcoll >= 30 ? "red" : "#000000" }}>{lengthcoll < 30 ? lengthcoll : 30}/30</div>
            </Form.Item>
            <Form.Item
              label="推送时间"
              colon
            >
              {getFieldDecorator("pushtimecoll", {
                initialValue: moment((colleagueRule || {}).pushTime || '09:00', format),
                rules: [
                  {
                    required: true,
                  }
                ]
              })(
                <TimePicker
                  format={format}
                  disabledHours={disabledHours}
                  disabledMinutes={disabledMinutes}
                  hideDisabledOptions
                />
              )}

              <div className={style.push_defual}>
                说明: 生日当天的推送时间
              </div>
            </Form.Item>
          </Form>
        </div>
        {/* <div className={style.model_root}>
          <PushImg />
        </div> */}
        <div className={style.footer}>
          <Button type="primary" htmlType="submit" onClick={this.handleSubmit}>保存</Button>
        </div>
        <Modal
          className='submit-modal'
          title={
            <div>
              <img src={question} alt="" />
              <span>确认要保存吗？</span>
            </div>
          }
          visible={visible}
          onOk={this.hideModal}
          onCancel={this.onCancel}
          okText="确认"
          cancelText="取消"
          closable={false}
        >
          <p>保存后将当天生效，请谨慎修改推送时间。</p>
        </Modal>
      </div>

    )
  }

}


const BirthdayPushWrappers = Form.create({ name: 'validate_other' })(BirthdayPush);

export default BirthdayPushWrappers;